import dynamic from "next/dynamic";
import ZendeskFormConfig from "./zendesk-form-config";
import ZendeskFormAdvancedConfig from "./zendesk-form-advanced-config";
const ZendeskFormComponent = dynamic(()=>import("./zendesk-form-component"));
export default {
    ZendeskFormComponent,
    ZendeskFormConfig,
    ZendeskFormAdvancedConfig
};
